import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converti en metre les valeurs en cm
 */
@Pipe({
  name: 'convertDistance',
})
export class ConvertDistancePipe implements PipeTransform {
  /**
   * Converti en unité en une autre
   * exemple : cm -> m
   *           kg -> g
   * @param value valeur à transformer
   * @param isMultiply si on doit le multiplier ou le diviser
   * @param ratio et par combien
   */
  transform(value: number, isMultiply: boolean, ratio: number): number {
    return isMultiply ? value * ratio : value / ratio;
  }
}
